import { api } from "@/utils/Api.util";

class HubspotClient {

	async getCompany(companyId: string) {

		const response = await api.get(`/hubspot/companies/${companyId}`);
		return response.data;

	}

}

export default HubspotClient;
